import {Component, OnInit} from '@angular/core';
import {AlertNoticeLevel, AlertNoticeLevels, EntityAlertType, EntityAlertTypes, IAlertInfo} from '../../models/IAlertInfo.interface';
import {AlertInfo} from '../../models/AlertInfo.class';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {AlertsService} from '../../services/alerts.service';
import {IUserInfo} from '../../../users/models/userInfo.interface';
import {OurUserService} from '../../../users/services/user.service';
import {EcaConfirmDeleteModalOptions} from '../../../shared/models/confirm-delete-modal-options.class';
import {EcaConfirmProcessService} from '../../../shared/services/eca-confirm-process.service';
import {ExportExcelService} from '../../../common/services/export-excel.service';
import {DatePipe} from '@angular/common';
import {EcaConfirmInfoModalOptions} from '../../../shared/models/confirm-info-modal-options.class';
import {HelpConsts} from '../../../help/models/help-consts';
import {HelpModalService} from '../../../help/services/help-modal.service';
import {IHelpInfo} from '../../../help/models/i-help-info.interface';

@Component({
  selector: 'app-company-alerts-page',
  templateUrl: './company-alerts-page.component.html',
  styleUrls: ['./company-alerts-page.component.scss']
})
export class CompanyAlertsPageComponent implements OnInit {
  entityAlertType = EntityAlertType;
  loadingAlerts: boolean;
  isOnMobile = false;
  alertInfos: AlertInfo[];
  columns: any;
  loggedInUser: IUserInfo;
  alertsLoading = true;
  alertsFilter = {includeRisks: false, showOnlyRisks: false};
  showFilters = true;
  alertTypes = EntityAlertTypes;
  alertNoticeLevels = AlertNoticeLevels;

  constructor(private confirmProcessService: EcaConfirmProcessService,
              private ecaBreadcrumbService: EcaBreadcrumbService,
              private exportExcelService: ExportExcelService,
              private helpService: HelpModalService,
              private datePipe: DatePipe,
              private alertsService: AlertsService, private userService: OurUserService) {

  }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    const alertBreadcrumbs = new Array<IBreadcrumb>();
    alertBreadcrumbs.push({label: 'Action Alerts', iconName: 'bell'} as IBreadcrumb);
    this.userService.getLoggedInUser().subscribe(loggedInUser => {
      this.loggedInUser = loggedInUser;
      this.getAlertsForCompany(this.alertsFilter);
    });
    this.ecaBreadcrumbService.breadCrumbs.next(alertBreadcrumbs);
    this.columns = [
      {field: 'alertType', header: 'Type', type: 'alertType', colWidth: 'width: 10%;'},
      {field: 'title', header: 'Title', type: 'text', colWidth: 'width: 10%;'},
      {field: 'detailsHtml', header: 'Details', type: 'html', colWidth: 'width: 20%;'},
      {field: 'directLink', header: 'Link', type: 'link', colWidth: 'width: 10%;'},
      {field: 'followUpOn', header: 'Follow Up On', type: 'date', colWidth: 'width: 10%;'},
      {field: 'alertLevel', header: 'Alert Level', type: 'alertNoticeLevel', colWidth: 'width: 5%;'},
    ];
  }


  getAlertsForCompany(alertsFilter?: any) {
    this.alertsService.getCurrentAlerts(this.loggedInUser?.companyId, alertsFilter.includeRisks, alertsFilter.showOnlyRisks).subscribe(alertInfos => {
      this.alertInfos = [];
      alertInfos?.forEach(alertInfo => this.alertInfos.push(new AlertInfo(alertInfo)));
      this.alertsLoading = false;
    });
  }

  openAlertsLoadingHelp() {
    this.helpService.openHelpModal(HelpConsts.ActionAlertsHelp);

  }

  riskFilterChanged() {
    this.getAlertsForCompany(this.alertsFilter);
  }
  exportToExcel() {
    const alertInfosToExport = [];
    this.alertInfos.forEach( alertInfo =>{
      const temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = alertInfo.detailsHtml;
      const tempObject = {
        title: alertInfo.title,
        followUpOn: this.datePipe.transform(alertInfo.followUpOn, 'dd/MM/yyyy'),
        alertLevel: AlertNoticeLevels.find(c => c.value === alertInfo.alertLevel).label,
        alertType: EntityAlertTypes.find(c => c.value === alertInfo.alertType).label,
        detailsHtml: temporalDivElement.textContent || temporalDivElement.innerText || ''
      };
      alertInfosToExport.push(tempObject);
    });
    const exportColumns = [
      {field: 'title', header: 'Title', type: 'text'},
      {field: 'followUpOn', header: 'Follow Up On', type: 'date'},
      {field: 'alertLevel', header: 'Alert Level', type: 'alertNoticeLevel'},
      {field: 'alertType', header: 'Type', type: 'alertType', colWidth: 'width: 10%;'},
      {field: 'detailsHtml', header: 'Details', type: 'html', colWidth: 'width: 20%;'},
    ];
    this.exportExcelService.exportToExcel(alertInfosToExport, exportColumns, 'Alerts');

  }
  dismissAlert(alertInfo: AlertInfo) {
    const ecaConfirmDeleteModalOptions = new EcaConfirmDeleteModalOptions();
    ecaConfirmDeleteModalOptions.yesButtonText = 'Dismiss';
    this.confirmProcessService.openConfirmProcessModal('Are you SURE you wish to DISMISS this Alert?',
      'Confirm Dismiss', ecaConfirmDeleteModalOptions).subscribe(result => {
      if (result) {
        this.alertsService.dismissAlert(this.loggedInUser?.companyId, alertInfo.alertType, alertInfo.entityId).subscribe(res => {
          const index = this.alertInfos.findIndex(c => c === alertInfo);
          this.getAlertsForCompany(this.alertsFilter);
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe(res => {

          });
        });
      }
    });

  }
}
